module.exports = __webpack_public_path__ + "img/9788936456610.74cbe5f9.jpg";